import { render, staticRenderFns } from "./MatingDetail.vue?vue&type=template&id=729b775d&scoped=true&"
import script from "./MatingDetail.vue?vue&type=script&lang=js&"
export * from "./MatingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729b775d",
  null
  
)

export default component.exports